import { Injectable } from "@angular/core";
import * as _ from "underscore";

@Injectable({
  providedIn: "root",
})
export class HelperService {
  constructor() {}

  public each(array, delegate) {
    return _.each(array, delegate);
  }

  public where(array, search) {
    return _.where(array, search);
  }

  public filter(array, propiedades) {
    return _.filter(array, propiedades);
  }

  public find(array, propiedades) {
    return _.find(array, propiedades);
  }

  public findIndex(array, propiedades) {
    return _.findIndex(array, propiedades);
  }

  public sortBy(array, propiedades) {
    return _.sortBy(array, propiedades);
  }

  public findKey(object, propiedades) {
    return _.findKey(object, propiedades);
  }

  public uniq(array, param) {
    if (param == "clienteModificarRutero") {
      return _.uniq(array, (cliente: any) => cliente.idSucursalVentas);
    } else if (param == "ruteroTipoRutero") {
      return _.uniq(array, (rutero: any) => rutero.tipoRutero);
    } else if (param == "ruteroFrecuencias") {
      return _.uniq(array, (rutero: any) => rutero.idTpoFrecuencia);
    } else if (param == "ruteroDias") {
      return _.uniq(array, (rutero: any) => rutero.idDiaSemana);
    } else if (param == "agenciasSubordinados") {
      return _.uniq(
        array,
        (usuarioJerarquia: any) => usuarioJerarquia.idAgencia
      );
    } else if (param == "graficaLineal") {
      return _.uniq(
        array,
        (graficaLineal: any) => graficaLineal.horaVentaNovedad
      );
    } else if (param == "idProducto") {
      return _.uniq(array, (productos: any) => productos.idProducto);
    }
  }
}
